<template>
  <div class="row podcast-episode" v-if="podcast">
    <div class="image-box">
      <img v-if="podcast.image_url" :src="podcast.image_url" />
      <img v-else src="@/assets/img/podcast.png" />
      <a @click.stop="onOpenPodcast(podcast.enclosure_url)"
        ><div class="icon-circle text-white mr-2">
          <i class="cs-icons-play-filled"></i>
        </div>
      </a>
    </div>

    <div class="col-md-6 podcast-box">
      <div class="cs-textstyle-paragraph-small-bold">
        {{ podcast.created_at | moment('MMM DD, YYYY') }}
      </div>
      <div class="cs-textstyle-section-heading single-line-paragraph">
        {{ podcast.title }}
      </div>
      <div class="cs-textstyle-paragraph description">
        <app-expandable-text
          :content="podcast.description | text"
          placeholder="No description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppExpandableText from '@/components/global/ExpandableText.vue';
export default {
  components: {
    AppExpandableText
  },
  props: {
    podcast: {
      type: Object,
      required: true
    }
  },
  methods: {
    onOpenPodcast(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
.podcast-episode {
  cursor: pointer;
}
img {
  border-radius: 10px;
  height: 197px;
  width: 206px;
  @include media-breakpoint-up(md) {
    height: 197px;
    width: 206px;
  }
}
.single-line-paragraph {
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
}
.icon-circle {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  background: $primary;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  padding: 2px 0px 0px 1px;
}
.image-box {
  position: relative;
  height: 197px;
}
@media (max-width: 767px) {
  .image-box {
    width: 100%;
  }
  .image-box img {
    height: 200px;
    width: 100%;
    object-fit: cover;
  }
  .podcast-box {
    margin-top: 10px;
  }
  .podcast-episode {
    margin-bottom: 20px;
    padding-left: 1.5rem;
    padding-right: 0px;
  }
  .description {
    margin-top: 1px;
  }
}
@media (min-width: 768px) {
  .description {
    margin-top: 3px;
  }
}

.image-box a {
  position: absolute;
  right: -15px;
  bottom: -15px;
}
</style>
